var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { IconContainer } from './Icon.style';
export var Icon = React.forwardRef(function (props, ref) {
    var icon = props.icon, _a = props.colored, colored = _a === void 0 ? false : _a, rest = __rest(props, ["icon", "colored"]);
    var url = "//res.cloudinary.com/habx/image/upload/fl_sanitize/icons/".concat(icon, ".svg");
    return (React.createElement(IconContainer, __assign({ ref: ref, "data-colored": colored }, rest, { url: url })));
});
//# sourceMappingURL=Icon.js.map